import {
    Component, OnInit
} from '@angular/core';
import { HttpService } from '../../services/http.service';
import { getWindow } from 'ssr-window';
import { HttpErrorResponse } from '@angular/common/http';
import { CfAlertService } from '@crediblefinance/credible-ui';
import { Router } from '@angular/router';
import { WalletService } from '../../services/wallet.service';
import {
    MatDialog, MatDialogRef
} from '@angular/material/dialog';
import { ClaimMoonDialogComponent } from '../claim-moon-dialog/claim-moon-dialog.component';

@Component({
    selector: 'app-airdrop',
    templateUrl: './airdrop.component.html',
    styleUrls: [ './airdrop.component.scss' ]
})
export class AirdropComponent implements OnInit {
    width: any;
    constructor(public httpService: HttpService,
        private cfAlertService: CfAlertService,
        private router: Router,
        public walletService: WalletService,
        private dialog: MatDialog,
        private claimMoonDialogRef: MatDialogRef<ClaimMoonDialogComponent>
    ) {
        this.window = getWindow();
        this.width = this.window.outerWidth;
    }

    multiplier_tasks: Array<any> = [];
    non_multiplier_tasks: Array<any> = [];
    total_task_count: any;
    completed_task_count: any;
    pending_task_count: any;
    total_user_moon = 0;
    referred_user_count: any;
    invitation_link: any;
    questions: Array<any> = [];
    max: number = 5;
    current: number = 2;
    window: Window;
    kyc_loading: boolean = false;
    
    share_twitter_join_loading: boolean = false;

    ngOnInit(): void {
        this.getUserTasks();
        this.getUserMoons();
        this.getAirdropFaqQuestions();

        this.invitation_link = `${this.window.location.origin}/invite/${this.httpService.user.referral_code}`;

        this.attachSocketEvents();
    }

    attachSocketEvents() {
        this.httpService.socket.on('moons_updated', (data: any) => {
            this.total_user_moon += data.moons;
            this.getUserTasks();
            this.getUserMoons();
            this.httpService.getCurrentUser();
        });
    }

    get progress(): number {
        return (this.completed_task_count / this.total_task_count) * 100;
    }

    openQues(index: any) {
        this.questions[index].open = true;
    }

    closeQues(index: any) {
        this.questions[index].open = false;
    }

    redirectUrl(url: any) {
        this.window.open(url, '_blank');
    }
    
    getUserTasks() {
        this.httpService.getUserTasks().subscribe((res: any) => {
            const tasks = res.data.tasks;

            this.multiplier_tasks = tasks.filter((task: any) => task.multiplier);
            this.non_multiplier_tasks = tasks.filter((task: any) => !task.multiplier);

            this.total_task_count = res.data.tasks_count;
            this.completed_task_count = res.data.completed_task_count;
            this.pending_task_count = res.data.pending_task_count;
            this.referred_user_count = res.data.referred_user_count;
        }, (err: HttpErrorResponse) => {
            console.error(err);

            this.cfAlertService.showError(err);
        });
    }

    getAirdropFaqQuestions() {
        this.httpService.getAirdropFaqQuestions().subscribe((res: any) => {
            this.questions = res.data;
        }, (err: HttpErrorResponse) => {
            console.error(err);

            this.cfAlertService.showError(err);
        });
    }

    openClaimMoonDialog() {
        this.claimMoonDialogRef = this.dialog.open(ClaimMoonDialogComponent, {
            width: '550px',
            height: 'auto',
            data: {}
        });

        this.claimMoonDialogRef.afterClosed().subscribe((result) => {
            if (result)
                this.router.navigate([ '/transactions/my-moon-claim-history' ]);
        });
    }

    getUserMoons() {
        this.httpService.getUserMoons().subscribe(
            (res) => {
                this.total_user_moon = res.data.moons;
            },
            (err: HttpErrorResponse) => {
                console.error(err);

                this.cfAlertService.showError(err);
            }
        );
    }
}
